<template>
  <v-dialog v-model="visible" max-width="92vw" max-height="92vh" persistent @keydown.esc="onClose">
    <v-card class="spv-card">

      <!-- LIJEVO: PDF preview -->
      <div class="spv-left">
        <iframe
          v-if="blobUrl"
          ref="pdfFrame"
          :src="blobUrl"
          class="spv-iframe"
          seamless
        />
        <div v-else class="spv-loading">
          <v-progress-circular indeterminate color="#00BCD4" size="40" />
          <span>Učitavam dokument...</span>
        </div>
      </div>

      <!-- DESNO: akcije -->
      <div class="spv-right">

        <div class="spv-right-header">
          <v-icon size="22" color="#00BCD4" class="mr-2">mdi-check-circle-outline</v-icon>
          <div>
            <div class="spv-doc-title">{{ docTitle }} kreiran</div>
            <div v-if="receiptMeta && receiptMeta.receiptNumber" class="spv-doc-sub">
              Br. {{ receiptMeta.receiptNumber }}
            </div>
          </div>
        </div>

        <div class="spv-divider" />

        <!-- Gornja grupa gumba -->
        <div class="spv-btn-group">
          <button class="spv-action spv-action--primary" @click="onPrint">
            <v-icon size="18" color="white" class="mr-2">mdi-printer-outline</v-icon>
            Ispiši {{ docTitle.toLowerCase() }}
          </button>

          <button class="spv-action" @click="onEmail">
            <v-icon size="18" color="#00BCD4" class="mr-2">mdi-email-outline</v-icon>
            Pošalji e-mailom
          </button>

          <button class="spv-action" @click="onDownload">
            <v-icon size="18" color="#00BCD4" class="mr-2">mdi-download-outline</v-icon>
            Preuzmi PDF
          </button>
        </div>

        <div class="spv-spacer" />

        <!-- Zatvori / Nova naplata -->
        <button class="spv-action spv-action--close" style="margin-bottom:4px;" @click="onClose">
          <v-icon size="18" color="#64748B" class="mr-2">mdi-cash-register</v-icon>
          Zatvori · Nova naplata
        </button>

      </div>

    </v-card>

    <!-- Email modal -->
    <send-email ref="sendEmail" />
  </v-dialog>
</template>

<script>
import SendEmail from '@/modules/company/components/SendEmail.vue'
import state from '@/state'

export default {
  name: 'ShopPdfViewer',
  components: { SendEmail },

  data () {
    return {
      visible: false,
      pdf: null,
      blobUrl: null,
      receiptId: null,
      documentType: 'receipt',
      receiptMeta: null
    }
  },

  computed: {
    docTitle () {
      if (this.documentType === 'ponuda') return 'Ponuda'
      if (this.documentType === 'virman') return 'Virman'
      return 'Račun'
    }
  },

  methods: {
    open (pdf, { receiptId, documentType, receiptMeta } = {}) {
      this.pdf = pdf
      if (this.blobUrl) URL.revokeObjectURL(this.blobUrl)
      this.blobUrl = URL.createObjectURL(this.base64ToBlob(pdf))
      this.receiptId = receiptId || null
      this.documentType = documentType || 'receipt'
      this.receiptMeta = receiptMeta || null
      this.visible = true
    },

    close () {
      this.visible = false
      this.pdf = null
      if (this.blobUrl) { URL.revokeObjectURL(this.blobUrl); this.blobUrl = null }
      this.receiptId = null
    },

    onClose () {
      this.close()
      this.$emit('new-receipt')
    },

    base64ToBlob (b64) {
      const bytes = atob(b64)
      const arr = new Uint8Array(bytes.length)
      for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i)
      return new Blob([arr], { type: 'application/pdf' })
    },

    onPrint () {
      if (!this.blobUrl) return
      const iframe = document.createElement('iframe')
      iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;opacity:0;'
      iframe.src = this.blobUrl
      document.body.appendChild(iframe)
      iframe.addEventListener('load', () => {
        setTimeout(() => {
          iframe.contentWindow.print()
          setTimeout(() => document.body.removeChild(iframe), 2000)
        }, 300)
      }, { once: true })
    },

    onDownload () {
      if (!this.pdf) return
      const url = URL.createObjectURL(this.base64ToBlob(this.pdf))
      const a = document.createElement('a')
      a.href = url
      const num = (this.receiptMeta?.receiptNumber || '').replace(/[\\/:*?"<>|]/g, '-')
      a.download = num ? `${num}.pdf` : `${this.docTitle.toLowerCase()}.pdf`
      a.click()
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    },

    onEmail () {
      if (!this.receiptId) return
      const receipt = {
        id: this.receiptId,
        receiptNumberForEmail: this.receiptMeta?.receiptNumber || this.receiptId,
        total: this.receiptMeta?.total || 0,
        currency: this.receiptMeta?.currency || state.getCurrentCompany()?.currency || 'EUR',
        eracun_email: this.receiptMeta?.eracun_email || '',
        type: this.receiptMeta?.type || {}
      }
      const isOffer = this.documentType === 'ponuda'
      this.$refs.sendEmail.open(receipt, {
        action: isOffer ? 'OFFER_SENT' : 'EMAIL_SENT',
        title: isOffer ? 'Pošalji ponudu mailom' : 'Pošalji račun mailom',
        okBtn: 'Pošalji Email'
      })
    }
  }
}
</script>

<style scoped>
.spv-card {
  display: flex;
  flex-direction: row;
  height: 88vh;
  border-radius: 16px !important;
  overflow: hidden;
}

/* LIJEVO — PDF */
.spv-left {
  flex: 1;
  background: #F1F5F9;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 16px;
}
.spv-iframe {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
}
.spv-loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #94A3B8;
  font-size: 13px;
}

/* DESNO — akcije */
.spv-right {
  width: 280px;
  flex-shrink: 0;
  background: #ffffff;
  border-left: 1px solid #E2E8F0;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 12px;
}
.spv-btn-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.spv-right-header {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding-bottom: 4px;
}
.spv-doc-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.3;
}
.spv-doc-sub {
  font-size: 11px;
  color: #94A3B8;
  margin-top: 2px;
}
.spv-divider {
  height: 1px;
  background: #F1F5F9;
  margin: 4px 0;
  flex-shrink: 0;
}
.spv-action {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 11px 14px;
  border-radius: 10px;
  border: 1.5px solid #E2E8F0;
  background: #F8FAFC;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
  text-align: left;
  flex-shrink: 0;
}
.spv-action:hover {
  border-color: #00BCD4;
  color: #00BCD4;
  background: rgba(0,188,212,0.05);
}
.spv-action--primary {
  background: #00BCD4 !important;
  border-color: #00BCD4 !important;
  color: #ffffff !important;
  box-shadow: 0 2px 10px rgba(0,188,212,0.30);
}
.spv-action--primary:hover {
  background: #0097A7 !important;
  border-color: #0097A7 !important;
  color: #ffffff !important;
}
.spv-action--close {
  border-color: #E2E8F0;
  background: #F8FAFC;
  color: #64748B;
}
.spv-action--close:hover {
  border-color: #94A3B8;
  color: #374151;
  background: #F1F5F9;
}
.spv-spacer { flex: 1; }
</style>
